import { timetableRoutes } from './../time-table/timetable.routing';
import { deviationRoutes } from './../deviation/deviation.routing';
import { ElCheckListComponent } from './components/elchecklistList.component';
import { Route } from '@angular/router';
import { AuthGuard } from '../../_guards/index';
import { CommonViewComponent } from './../common/components/commonView.component';
export const elChecklistRoutes: Route[] = [
    {
        path: 'checklist',
        component: ElCheckListComponent,
        children: [
            {
                path: 'list',
                component: ElCheckListComponent
            },
            {
                path: 'details/:id',
                component: CommonViewComponent,
                data: { parent: 'VEHICLE' },
                canActivate: [AuthGuard],
                children: [
                    ...deviationRoutes,
                    ...timetableRoutes
                ]
            }]
    }

];
